/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { useTranslator } from '@jutro/locale';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { FormModalPopover } from 'ml-components-platform-react';
import { useModal } from '@jutro/components';

import MLDocumentsUploadPopup from '../../../gw-capability-gateway-react/Policies/MLDocumentsUploadPopup/MLDocumentsUploadPopup.jsx';
import messages from './DocumentUploadComponent.messages';
import styles from './DocumentUploadComponent.module.scss';

import { Link } from '@jutro/router';

function DocumentUploadComponent(props) {
    const modalApi = useModal();
    const { summary, openContingencies, formContingencies, policySummaries,authHeader, viewModelService } = props;
    const translator = useTranslator();

    const onUploadDocument = (contingencyId) => {
        const componentProps = {
            showHeader: false,
            overrideProps: {
                policyNumber: summary.policyId,
                policies: policySummaries,
                formContingencies: formContingencies,
                contingencyId
            },
            viewModelService,
            authHeader,
            CustomComponent: MLDocumentsUploadPopup
        };

        modalApi.showModal(
            <FormModalPopover {...componentProps} />
        )
    };

    return (
        <>
            {openContingencies && openContingencies.length > 0 &&
            <div className="vertical-spacing-40">
                <div className="row">
                    <div className="col-md-12">
                        <div className="padding-left-5 ml-cta ml-cta--error">
                            <span className="icon-ml-alert-icon padding-right-5" />
                            <span>Action Required</span>
                        </div>
                        <ul className={cx(styles.styledUlList, 'padding-left-5')}>
                            {openContingencies.map((contingency) => {
                                return (
                                    <li>
                                        <span>{contingency.title}</span>
                                        <Link onClick={() => onUploadDocument(contingency.publicId)} className='padding-left-5'>
                                            {translator(messages.uploadDocument)}
                                        </Link>
                                    </li>
                                )
                            })}
                        </ul>
                    </div>
                </div>
            </div>
            }
        </>
    );
}

DocumentUploadComponent.propTypes = {
    summary: PropTypes.object.isRequired,
    openContingencies: PropTypes.object.isRequired,
    formContingencies: PropTypes.object.isRequired,
    policySummaries: PropTypes.object.isRequired,
}

export default DocumentUploadComponent;